import { inject, Injectable } from '@angular/core';
import { FeedStore } from './feed.store';
import { withTransaction } from '@datorama/akita';
import { finalize } from 'rxjs';
import { FeedResultModel } from './models/feed-result.model';
import { ApiService } from '../shared/services/core/api.service';

@Injectable({
  providedIn: 'root',
})
export class FeedService {
  private api = inject(ApiService);
  private store = inject(FeedStore);

  fetchDynamicLoyaltyFeed() {
    this.store.setLoading(true);
    return this.api.getAnySingle<FeedResultModel>('portalfeed').pipe(
      withTransaction((response: FeedResultModel) => {
        console.log('Dynamic Loyalty Feed: ', response);
        this.store.setDynamicLoyaltyFeeds(response.DynamicFeed);
      }),
      finalize(() => this.store.setLoading(false))
    );
  }
}
